import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuthUser } from '../../context/AuthUserContext';
import ModalRelacionado from './ModalRelacionado';
const API = 'https://centrocomunicar.com/api-comunicar/endpoints/relacionados_admin.php';

const IconCartPlus = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconTick = ({ on }) => (
  <span style={{
    width:20, height:20, borderRadius:6, flexShrink:0,
    border: `2px solid ${on ? '#14736C' : 'rgba(139,202,175,.5)'}`,
    background: on ? '#14736C' : '#fff',
    display:'flex', alignItems:'center', justifyContent:'center',
  }}>
    {on && <svg viewBox="0 0 24 24" fill="none" width="12" height="12"><polyline points="20 6 9 17 4 12" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/></svg>}
  </span>
);

const soles = (n) => `S/. ${Number(n || 0).toFixed(2)}`;
const cartIdDe = (p) => p.tipo === 'curso' ? 'curso-' + p.id : p.id;

export default function RelacionadosCurso({ origenTipo, origenId, origenTitulo, origenPrecio, origenImagen, redirectLogin }) {
    
  const [items,     setItems]     = useState([]);
  const [marcados,  setMarcados]  = useState(() => new Set());
  const [cargando,  setCargando]  = useState(true);
  const [verDetalle, setVerDetalle] = useState(null);

  const navigate = useNavigate();
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();

  useEffect(() => {
    let vivo = true;
    fetch(`${API}?action=publicos&origen_tipo=${origenTipo}&origen_id=${origenId}`)
      .then(r => r.json())
      .then(j => {
        if (!vivo) return;
        
        
        const data = j.success ? (j.data || []) : [];
        setItems(data);


      })
      .catch(() => {})
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, [origenTipo, origenId]);

  const cursoEnCarrito = estaEnCarrito(cartIdDe({ tipo: origenTipo, id: origenId }));

  const seleccionados = useMemo(
    () => items.filter(p => marcados.has(cartIdDe(p)) && !estaEnCarrito(cartIdDe(p))),
    [items, marcados, estaEnCarrito]
  );

  const toggle = (p) => {
    const k = cartIdDe(p);
    setMarcados(s => {
      const n = new Set(s);
      n.has(k) ? n.delete(k) : n.add(k);
      return n;
    });
  };

  /* Totales del paquete: el curso solo suma si aún no está en el carrito */
  const baseCurso   = cursoEnCarrito ? 0 : Number(origenPrecio || 0);
  const totalNormal = baseCurso + seleccionados.reduce((a, p) => a + p.precio, 0);
  const totalPack   = baseCurso + seleccionados.reduce((a, p) => a + p.precio_paquete, 0);
  const ahorro      = totalNormal - totalPack;

  const exigirLogin = () => {
    if (estaLogueado) return false;
    navigate(redirectLogin || '/login?redirect=/formaciones');
    return true;
  };

  const agregarPaquete = () => {
    if (exigirLogin()) return;
    if (!cursoEnCarrito && Number(origenPrecio) > 0) {
      agregarItem({
        id:      cartIdDe({ tipo: origenTipo, id: origenId }),
        titulo:  origenTitulo,
        precio:  Number(origenPrecio),
        tipo:    'curso',
        color:   'verde',
        imagen:  origenImagen || null,
        digital: true,
      });
    }
    seleccionados.forEach(p => {
      if (estaEnCarrito(cartIdDe(p))) return;
      agregarItem({
        id:      cartIdDe(p),
        titulo:  p.titulo,
        precio:  p.precio_paquete,
        precio_lista:  p.precio,
        descuento_pct: p.descuento_pct,
        paquete_de:    cartIdDe({ tipo: origenTipo, id: origenId }),
        tipo:    p.tipo === 'curso' ? 'curso' : 'recurso',
        color:   'verde',
        imagen:  p.imagen_url || null,
        digital: true,
      });
    });
  };

  const agregarSuelto = (p) => {
    if (exigirLogin()) return;
    agregarItem({
      id:      cartIdDe(p),
      titulo:  p.titulo,
      precio:  p.precio,
      tipo:    p.tipo === 'curso' ? 'curso' : 'recurso',
      color:   'verde',
      imagen:  p.imagen_url || null,
      digital: true,
    });
  };


 
  if (cargando || items.length === 0) return null;

  const hayDescuento = items.some(p => p.descuento_pct > 0);

  return (
    <div className="cd-card">
      <h2>También te puede interesar</h2>
      {hayDescuento && (
        <p style={{ margin:'-.4rem 0 1.1rem', fontSize:'.88rem', color:'#5a6a63', lineHeight:1.6 }}>
          Llevándolos junto con este curso pagas menos que por separado.
        </p>
      )}

      <div style={{ display:'flex', flexDirection:'column', gap:'.6rem' }}>
        {items.map(p => {
          const k  = cartIdDe(p);
          const ya = estaEnCarrito(k);
          const on = marcados.has(k);
          const conDto = p.descuento_pct > 0;

          return (
           
           
            <div key={k}
            onClick={() => !ya && toggle(p)}
            style={{
              display:'flex', alignItems:'center', gap:'.85rem',
              background: ya ? '#f3f8f5' : (on ? '#f7fdfa' : '#fff'),
              border: `1.5px solid ${on && !ya ? '#14736C' : 'rgba(139,202,175,.28)'}`,
              borderRadius:14, padding:'.8rem .95rem',
              cursor: ya ? 'default' : 'pointer',
              opacity: ya ? .7 : 1,
              transition:'border-color .18s, background .18s',
            }}>

            {!ya && <IconTick on={on}/>}



              {p.imagen_url
                ? <img src={p.imagen_url} alt="" style={{ width:58, height:58, borderRadius:10, objectFit:'cover', flexShrink:0 }}/>
                : <div style={{ width:58, height:58, borderRadius:10, background:'#edfaf4', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.3rem', flexShrink:0 }}>
                    {p.tipo === 'curso' ? '🎓' : '📄'}
                  </div>}

              <div style={{ flex:1, minWidth:0 }}>
                <strong style={{ fontSize:'.92rem', color:'#111614', display:'block', lineHeight:1.35 }}>{p.titulo}</strong>
                <span style={{ fontSize:'.76rem', color:'#5a6a63' }}>
                  {p.tipo === 'curso' ? 'Curso' : 'Material'} · {p.categoria}
                </span>
                <button
                  onClick={(e) => { e.stopPropagation(); setVerDetalle(p); }}
                  style={{ display:'block', marginTop:'.3rem', background:'none', border:'none', padding:0, color:'#14736C', fontFamily:'inherit', fontSize:'.76rem', fontWeight:700, cursor:'pointer', textDecoration:'underline' }}>
                  Ver detalle
                </button>
              </div>

              <div style={{ textAlign:'right', flexShrink:0 }}>
                {conDto ? (
                  <>
                    <s style={{ fontSize:'.78rem', color:'#9ca3af', display:'block' }}>{soles(p.precio)}</s>
                    <strong style={{ fontSize:'1rem', color:'#14736C' }}>{soles(p.precio_paquete)}</strong>
                    <span style={{ display:'block', fontSize:'.68rem', fontWeight:700, color:'#14736C' }}>
                      −{Math.round(p.descuento_pct)}%
                    </span>
                  </>
                ) : (
                  <strong style={{ fontSize:'1rem', color:'#111614' }}>{soles(p.precio)}</strong>
                )}
              </div>

           
              {ya ? (
                <button
                  onClick={(e) => { e.stopPropagation(); navigate('/carrito'); }}
                  style={{ display:'flex', alignItems:'center', gap:'.3rem', background:'none', border:'none', color:'#4db88a', fontFamily:'inherit', fontWeight:700, fontSize:'.75rem', cursor:'pointer', flexShrink:0, whiteSpace:'nowrap' }}>
                  ✓ En el carrito
                </button>
              ) : (
                <button
                  onClick={(e) => { e.stopPropagation(); agregarSuelto(p); }}
                  title={conDto ? 'Agregar solo este, a precio normal' : 'Agregar al carrito'}
                  style={{ display:'flex', alignItems:'center', gap:'.3rem', background:'#edfaf4', color:'#14736C', border:'1.5px solid rgba(139,202,175,.45)', borderRadius:100, padding:'.45rem .9rem', fontFamily:'inherit', fontWeight:700, fontSize:'.78rem', cursor:'pointer', flexShrink:0, whiteSpace:'nowrap' }}>
                  <IconCartPlus/> Agregar
                </button>
              )}



            </div>
          );
        })}
      </div>

      {/* Resumen del paquete */}
      {hayDescuento && seleccionados.length > 0 && (
        <div style={{
          marginTop:'1.1rem', background:'#edfaf4',
          border:'1.5px solid rgba(139,202,175,.4)', borderRadius:14,
          padding:'1rem 1.2rem', display:'flex', alignItems:'center',
          justifyContent:'space-between', flexWrap:'wrap', gap:'.9rem',
        }}>
          <div>
            <p style={{ margin:0, fontSize:'.7rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'.09em', color:'#4db88a' }}>
              Paquete
            </p>
            <p style={{ margin:'.25rem 0 0', fontSize:'.86rem', color:'#5a6a63' }}>
              {cursoEnCarrito
                ? `${seleccionados.length} material${seleccionados.length>1?'es':''} seleccionado${seleccionados.length>1?'s':''}`
                : `Este curso + ${seleccionados.length} material${seleccionados.length>1?'es':''}`}
            </p>
            {ahorro > 0 && (
              <p style={{ margin:'.3rem 0 0', fontSize:'.82rem', fontWeight:700, color:'#14736C' }}>
                Ahorras {soles(ahorro)}
              </p>
            )}
          </div>

          <div style={{ display:'flex', alignItems:'center', gap:'1rem', flexWrap:'wrap' }}>
            <div style={{ textAlign:'right' }}>
              {ahorro > 0 && <s style={{ fontSize:'.85rem', color:'#9ca3af', display:'block' }}>{soles(totalNormal)}</s>}
              <strong style={{ fontSize:'1.3rem', color:'#111614' }}>{soles(totalPack)}</strong>
            </div>
            <button onClick={agregarPaquete}
              style={{ display:'flex', alignItems:'center', gap:'.45rem', background:'#032D29', color:'#8BCAAF', border:'none', borderRadius:100, padding:'.8rem 1.5rem', fontFamily:'inherit', fontWeight:700, fontSize:'.88rem', cursor:'pointer', whiteSpace:'nowrap' }}>
              <IconCartPlus/> Agregar paquete
            </button>
          </div>


    </div>
      )}

      {verDetalle && (
        <ModalRelacionado
          producto={verDetalle}
          enCarrito={estaEnCarrito(cartIdDe(verDetalle))}
          onAgregar={agregarSuelto}
          onVerCarrito={() => navigate('/carrito')}
          onCerrar={() => setVerDetalle(null)}
        />
      )}
    </div>
  );
}